import { defineStore } from 'pinia'

export default defineStore({
  id: 'driverDataTable',
  persist: true,
  state: () => {
    return {
      columnState: [],
      isDriverArchive: false,
      isDriverDocumentArchive: false,
      isDriverLicenseArchive: false
    }
  },
  actions: {
    setColumnDriverState: function (payload: any) {
      this.columnState = payload
    },
    setIsDriverArchive: function (payload: any) {
      this.isDriverArchive = payload
    },
    setIsDriverDocumentArchive: function (payload: any) {
      this.isDriverDocumentArchive = payload
    },
    setIsDriverLicenseArchive: function (payload: any) {
      this.isDriverLicenseArchive = payload
    }
  },
  getters: {
    getColumnDriverState: (state: any) => state.columnState,
    getIsDriverArchive: (state: any) => state.isDriverArchive,
    getIsDriverDocumentArchive: (state: any) => state.isDriverDocumentArchive,
    getIsDriverLicenseArchive: (state: any) => state.isDriverLicenseArchive
  }
})
